import { DashboardRecentActivity } from "../../pages/api/dashboard";
import Link from "next/link";
import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { da, enUS, nb, sv } from "date-fns/locale";

interface RecentActivityProps {
  activities: DashboardRecentActivity[];
}

const localeMap: Record<string, Locale> = {
  da: da,
  en: enUS,
  no: nb,
  sv: sv,
};

export default function RecentActivity({ activities }: RecentActivityProps) {
  const { t } = useTranslation();
  const router = useRouter();
  const dateLocale = localeMap[router.locale || "en"] || enUS;

  return (
    <div className="card h-100">
      <div className="card-header">
        <h6 className="mb-0">{t("dashboard.recentPatientActivity")}</h6>
      </div>
      <div className="card-body p-0">
        {activities.length === 0 ? (
          <p className="text-muted p-3 mb-0">
            {t("dashboard.noRecentActivity")}
          </p>
        ) : (
          <ul className="list-group list-group-flush">
            {activities.map((activity) => (
              <li
                key={`${activity.activityType}-${activity.id}`}
                className="list-group-item d-flex justify-content-between align-items-start"
              >
                <div className="ms-2 me-auto">
                  <Link
                    href={`/users/${activity.userId}`}
                    className="fw-bold text-decoration-none"
                  >
                    {activity.userName ||
                      activity.userEmail ||
                      t("dashboard.unknownUser")}
                  </Link>
                  <div>
                    <small className="text-muted">
                      {t(`dashboard.activityTypes.${activity.activityType}`)}
                    </small>
                  </div>
                </div>
                <small className="text-muted">
                  {formatDistanceToNow(new Date(activity.createdAt), {
                    addSuffix: true,
                    locale: dateLocale,
                  })}
                </small>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
